module.exports = __webpack_public_path__ + "static/mediajustice-a90ff121c14fb99946ce721462b70627.png";